import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from './searchResults';


@JsonObject('Notification')
export class Notification {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('verb', String, true)
    message = '';

    @JsonProperty('timestamp', String, true)
    timestamp = '';

    @JsonProperty('unread', Boolean, true)
    unread = true;

    @JsonProperty('redirect_url', String, true)
    redirectUrl = null;
}


@JsonObject('NotificationSearchResults')
export class NotificationSearchResults extends SearchResults {
    @JsonProperty('results', [Notification], true)
    results: Notification[] = [];

    @JsonProperty('unread_count', Number, true)
    unreadCount = 0;
}


@JsonObject('WebsocketNotification')
export class WebsocketNotification {
    @JsonProperty('unread_count', Number, true)
    unreadCount = 0;

    @JsonProperty('unread', Notification, true)
    unread: Notification = null;
}

